import { createStore } from 'vuex';
import { RootState } from './types';
import { api } from './api/index';
import { form } from './form/index';
import { ActionTypes as FormActions } from './form/actions';
import { GetterTypes as FormGetters } from './form/getters';
import { ActionTypes as ApiActions } from './api/actions';
import { GetterTypes as ApiGetters } from './api/getters';

export enum Modules {
    API = 'api',
    FORM = 'form'
}

const store = createStore<RootState>({
    state: {
        version: '1.0.0',
    },
    modules: {
        [Modules.API]: api,
        [Modules.FORM]: form
    },
    mutations: {

    },
    actions: {

    },
});

export { FormActions, FormGetters, ApiActions, ApiGetters };
export default store;